import archive from './archive';
import updateState from './update-state';

export default [archive(), updateState()];
